module.exports = function isString(x) {
  return typeof x === 'string';
};


//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/isString.js
// module id = 115
// module chunks = 114276838955818